const ControlSeparator = () => {
	return <hr className="czgb-control-separator" />
}

export default ControlSeparator
